<template>
  <div class="home-banner min-height" >
    <!-- :interval="4000" -->
    <!-- controls  -->
    <b-carousel
      id="carousel-1"
      :interval="40100"
      v-model="slide"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      class="min-height"
    >
      <!-- :src="item.imageUrl" -->
      <b-carousel-slide style="cursor: pointer;" v-for="(item,index) in carousels" :key="index" @click.native="toDetail(item)" class="min-height">
        <!-- <b-carousel-slide v-for="(item,index) in carousels" :key="index"> -->
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100 img_item min-height"
            :src="item.bannerImgUrl"
            alt=""
          />
        </template>
        <h1 class="banner-txt cover-txt">
          {{item.postTitle}}
        </h1>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  props: {
    carousels: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: "Banner",
  data() {
    return {
      //banner
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    setImgUrl() {
      return function(url) {
        if (url.indexOf("http") > -1) {
          return url;
        } else {
          return this.$store.state.baseUrl + "/file/" + url;
        }
      };
    },
  },
  mounted() {
    // 首页图片16/9
    this.handelWidth();
  },
  methods: {
    // 处理首页图片
    handelWidth() {
      var container = document.getElementsByClassName("min-height");
      this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
      if (container[0].clientWidth > 750) {
        for (var i = 0; i < container.length; i++) {
          container[i].style.height = this.playerHeight;
        }
      }
    },
    // banner
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    toDetail(item) {
      this.$router
        .push({
          path: "/detail",
          query: {
            postId: item.postId,
          },
        })
        .catch(err => {
          err;
        });
    },
  },
};
</script>

<style lang="less">
.home-banner {
  //修改轮播图的点显示
  h1 {
    font-size: 36px;
    font-family: FranklinGothic-Demi;
    // font-weight: bold;
    color: rgba(255, 255, 255, 1);
    position: relative;
    top: -0.1rem;
    margin-bottom: 0;
    text-shadow: none;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .carousel-caption {
    // padding-bottom: 0;
    width: 90%;
    text-align: left;
    left: 5%;
    right: 5%;
    padding-bottom: 6px !important;
  }
  .home-banner:hover .carousel-control-next-icon {
    display: block;
  }
  .carousel-control-next-icon {
    height: 40px;
    width: 40px;
    position: absolute;
    right: 30px;
  }
  .carousel-control-prev-icon {
    height: 40px;
    width: 40px;
    position: absolute;
    left: 30px;
  }

  .carousel-item::after {
    bottom: 0;
    content: "";
    display: block;
    height: 50%;
    width: 100%;
    position: absolute;
    z-index: 1;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 30%,
      rgba(0, 0, 0, 0.8) 100%
    );
  }
  li {
    outline: none !important;
  }
  .carousel-item {
    height: 8rem;
  }
  .img_item {
    max-width: initial;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
  }
  .carousel-indicators li {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: transparent;
    border: 1px solid #ccc;
  }
  .carousel-indicators li.active {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #3bbbd7;
    border: 1px solid #a2a2a2;
  }
  ol,
  ul,
  dl {
    margin-bottom: 0.2rem;
  }
}
@media screen and (max-width: 768px) {
  .home-banner .carousel-indicators li {
    width: 5px !important;
    height: 5px !important;
  }
  .home-banner .carousel-indicators li.active {
    width: 5px !important;
    height: 5px !important;
  }
  .home-banner {
    .carousel-item {
      height: 5.5rem;
    }
    h1 {
      font-size: 21px;
      letter-spacing: 1px;
      top: 0.2rem;
    }

    .carousel-control-next-icon {
      height: 20px;
      width: 20px;
      position: absolute;
      right: 20px;
      display: none;
    }
    .carousel-control-prev-icon {
      height: 20px;
      width: 20px;
      position: absolute;
      left: 20px;
      display: none;
    }
  }
}
</style>